import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-foreground-500 mt-3 text-sm md:text-base">
            关于吃瓜视频在线观看完整版延禧攻略等热门剧集的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer hover:bg-background-100 transition-colors duration-150"
              >
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                  <i
                    className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-lg text-foreground-500 transition-transform duration-200`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}